import { type TRefundTerm } from '@/entities/contract'
import { Description } from '@/shared/ui'

import {
  getDiffDateText,
  getDiffDayText,
  getPenaltyText,
} from '../../lib/refund-term'

export type Props = {
  refundTerms: TRefundTerm[]
  isOldRefundTerms: boolean
}

export const TerminationFee = ({ isOldRefundTerms, refundTerms }: Props) => {
  return (
    <div className="px-6">
      <h5 className="typo-label1 mb-3 font-semibold text-gray-900">
        계약 취소 시 환불 규정
      </h5>

      <Description.List>
        <Description.Item className="justify-between">
          <Description.ItemLabel className="typo-label2">
            취소일
          </Description.ItemLabel>
          <Description.ItemValue className="typo-label2 text-gray-500">
            위약금
          </Description.ItemValue>
        </Description.Item>

        {refundTerms.map(refundTerm => (
          <Description.Item
            key={refundTerm.fromDate}
            className="typo-label2 justify-between *:font-normal"
          >
            <Description.ItemLabel className="space-x-0.5">
              <span className="text-gray-900">
                {getDiffDayText(refundTerm.toDateDiffDays)}
              </span>
              <span>
                {getDiffDateText(refundTerm.fromDate, refundTerm.toDate)}
              </span>
            </Description.ItemLabel>
            <Description.ItemValue>
              {getPenaltyText(refundTerm.cancelFeePercent, isOldRefundTerms)}
            </Description.ItemValue>
          </Description.Item>
        ))}
      </Description.List>
    </div>
  )
}
